/* eslint-disable keyword-spacing */
/* eslint-disable eqeqeq */
/* eslint-disable quotes */
/* eslint-disable no-mixed-spaces-and-tabs */
import api from "@/api";
import LocalStorageTool from "@/util/localStorageTool";
import * as Sentry from "@sentry/vue";
export default {
    state: {
        companyId: 755,
        workspaceId: 755,
        workspaceName: "TAPD平台",
        userInfo: null,
        userId: 2012,
        code: "",
        apiToken: "",
        socketToken: "",
        appMessageInit: false,
        appMessageCallbaks: [],
        userPermissions: [],
        socketInit: false,
        meettingWebViewTapdloginApiToken: "",
        lang: "zh",
    },
    getters: {
        apiToken: (state) => {
            // 这里存在这bug，当一个用户登陆之后，同一台电脑tapd切换用户之后登陆由于token缓存着所以token还是上一个用户。
            let token = LocalStorageTool.getLocalStorage('token');
            if (token && token != state.apiToken) {
                state.apiToken = token;
            }
            return state.apiToken;
        },
        statApiToken: (state) => {
            return state.apiToken;
        },
        meettingWebViewTapdloginApiToken: (state) => {
            return state.meettingWebViewTapdloginApiToken;
        },
        userInfo: (state) => {
            //内网从state拿,云端还是localstorage
            return process.env.VUE_APP_IS_CLOUD == 1 ? LocalStorageTool.getObjectFromLocalStorage('user_info', state.userInfo) : state.userInfo;
        },
        userPermissions: (state) => {
            //内网从state拿,云端还是localstorage
            return process.env.VUE_APP_IS_CLOUD == 1 ? LocalStorageTool.getObjectFromLocalStorage('user_permission', state.userPermissions) : state.userPermissions;
        },
        socketToken: (state) => {
            //内网从state拿,云端还是localstorage
            return process.env.VUE_APP_IS_CLOUD == 1 ? LocalStorageTool.getObjectFromLocalStorage('socket_token', state.socketToken) : state.socketToken;
        },
        code: (state) => {
            return state.code;
        },
    },
    mutations: {
        socketInit(state) {
            state.socketInit = true;
        },
        setCompanyId(state, companyId) {
            state.companyId = companyId;
        },
        setWorkspaceId(state, workspaceId) {
            state.workspaceId = workspaceId;
        },
        setUserInfo(state, userInfo) {
            localStorage.setItem('user_info', JSON.stringify(userInfo));
            state.userInfo = userInfo;
            Sentry.setUser({ username: userInfo.nick })
        },
        setStatUserInfo(state, userInfo) {
            state.userInfo = userInfo;
            Sentry.setUser({ username: userInfo.nick })
        },
        setApiToken(state, apiToken) {
            localStorage.setItem('token', apiToken);
            state.apiToken = apiToken;
        },
        setStatApiToken(state, apiToken) {
            state.apiToken = apiToken;
        },
        setMeettingWebViewTapdloginApiToken(state, apiToken) {
            state.meettingWebViewTapdloginApiToken = apiToken;
        },
        setSocketToken(state, socketToken) {
            let save = {
                data_id: socketToken.dataId,
                timespan: socketToken.timespan,
                token: socketToken.token,
                user_nick: socketToken.userNick,
                workspace_id: socketToken.workspaceId,
            };
            localStorage.setItem('socket_token', JSON.stringify(save));
            state.socketToken = save;
        },
        setStatSocketToken(state, socketToken) {
            let save = {
                data_id: socketToken.dataId,
                timespan: socketToken.timespan,
                token: socketToken.token,
                user_nick: socketToken.userNick,
                workspace_id: socketToken.workspaceId,
            };
            state.socketToken = save;
        },        
        setCode(state, code) {
            state.code = code;
        },
        appMessageInited(state) {
            state.appMessageInit = true;
        },
        addMessageCallbacks(state, { eventType, fn, once }) {
            if (typeof state.appMessageCallbaks[eventType] == 'undefined') {
                state.appMessageCallbaks[eventType] = [];
            }
            state.appMessageCallbaks[eventType].push({
                fn,
                once
            });
        },
        removeMessageCallbacks(state, { eventType, index }) {
            if (state.appMessageCallbaks[eventType]) {
                state.appMessageCallbaks[eventType].splice(index, 1);
            }
        },
        setUserPermissions(state, permissions) {
            let save = permissions.map((value) => (value.key));
            localStorage.setItem('user_permission', JSON.stringify(save));
            state.userPermissions = save;
        },
        setStatUserPermissions(state, permissions) {
            let save = permissions.map((value) => (value.key));
            state.userPermissions = save;
        },        
        setLanguage(state, lang) {
            state.lang = lang;
        }
    },
    actions: {
        setCompanyId({ commit }, value) {
            commit('setCompanyId', value);
        },
        setWorkspaceId({ commit }, value) {
            commit('setWorkspaceId', value);
        },
        setLanguage({ commit }, value) {
            commit('setLanguage', value);
        },
        async login({ commit }, { type, options = [] }) {
            try {
                if(process.env.VUE_APP_IS_CLOUD == 1){
                    let res = await api.base.login(this.state.code, type, options);
                    if (type == "meeting_webview") {
                        commit('setStatUserInfo', res);
                        commit('setStatApiToken', res.apiToken);
                    } else if (type == "meeting_webview_tapd_login" && res.apiToken) {
                        commit('setMeettingWebViewTapdloginApiToken', res.apiToken);
                        commit('setStatApiToken', res.apiToken);
                        commit('setStatUserInfo', res);
                    } else {
                        commit('setUserInfo', res);
                        commit('setApiToken', res.apiToken);
                    }
    
                    res.socketToken && commit('setSocketToken', res.socketToken);
                    res.permissions && commit('setUserPermissions', res.permissions);
                }else{
                    let res = await api.base.login(this.state.code, type, options);
                    commit('setStatUserInfo', res);
                    res.socketToken && commit('setStatSocketToken', res.socketToken);
                    res.permissions && commit('setStatUserPermissions', res.permissions);
                }

            } catch (e) {
                console.log(e);
            }
        },
        async permissions({ commit }) {
            let res = await api.user.permissions();
            commit('setUserPermissions', res);
        },
        closeLoading({ commit }) {
            commit('loading', false);
        },
        setCode({ commit }, code) {
            commit('setCode', code);
        },
        setAppMessageInit({ commit }) {
            commit('appMessageInited');
        },
        // 添加事件监听，fn为事件，once标识是否回调一次删除
        addAppMessageCallBacks({ commit }, { eventType, fn, once = true }) {
            commit('addMessageCallbacks', { eventType, fn, once });
        },
        // 删除事件
        removeAppMessageCallBacks({ commit }, { eventType, index }) {
            commit('removeMessageCallbacks', { eventType, index });
        }
    }
}
